import { createServiceAction } from '../util/actionHelper.js';
import { apiConfig } from '../configs/apiConfig.js';
import { getRequest } from '../util/index.js';
import { getHTTPStatusValidationMessage, getServerValidationMessage } from '../services/serverValidations.js';

import { put, takeEvery, call} from 'redux-saga/effects';

function* listener(serviceType) {
  try {
    yield put(createServiceAction(serviceType, 'loading')());
    
    const res = yield call(getRequest, apiConfig.getFilterHistory.endPointUrl);
    // Display HTTP status error message
    const statusErrorMessage = yield call(getHTTPStatusValidationMessage, res);
    if(!statusErrorMessage){ 
      const response = yield res.json();
      // Display server error message
      const serverErrorMessage = yield call(getServerValidationMessage, response);
      if (!serverErrorMessage && response.errorCode === 0) {
        yield put(createServiceAction(serviceType, 'success')(response.data));
      }
    }
  } catch (e) {
    yield put(createServiceAction(serviceType, 'error')(e));
  }
}

function* getFilterHistory() {
  const serviceType = 'getFilterHistory';
  yield takeEvery(createServiceAction(serviceType, 'requested').type, listener, serviceType);
}

export default getFilterHistory;
